import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { LOGIN_ROUTE } from "../../config/RoutesConstants"
import {
  Field,
  reduxForm,
  formValueSelector,
  change,
  getFormValues
} from "redux-form";
import { TextField, Select } from "redux-form-material-ui";
import { required, typeIntegerOrDecimalOr0, typeInteger } from "../../common/Validations";
import { 
  Box, 
  Button,
  Container, 
  Checkbox,
  Dialog,
  DialogActions,
  DialogTitle,
  Divider,
  IconButton,
  InputLabel,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Fab,
  Grid,
  Paper,
  Typography, 
  Tooltip,
  Input,
  InputAdornment,
  Icon,
  Tab,
  Tabs,
  Toolbar,
  MenuItem,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell
} from "@material-ui/core"
import SelectMaterial from "@material-ui/core/Select"
import { Autocomplete } from"@material-ui/lab"
import AddIcon from "@material-ui/icons/Add"
import GoogleMapLocation from "../../components/GoogleMapLocation"
import { withTheme } from "@material-ui/core/styles"
import BackIcon from '@material-ui/icons/ArrowBackRounded';
import FacebookIcon from '@material-ui/icons/Facebook';
import InstagramIcon from '@material-ui/icons/Instagram';
import TwitterIcon from '@material-ui/icons/Twitter';
import Util, { ERROR, SUCCESS, handleSubmitFail } from '../../common/Util'
import ImageSelector from '../../components/ImageSelector/ImageSelector'
import Crop from '../../components/Crop'
import { actionSaveRestaurant } from '../../actions/RestaurantActions'
import { actionSavePlace } from '../../actions/PlaceActions'
import Roles from "../../config/RolesConstants"
import moment from 'moment'
let _handleSubmitFail;
class AddEditRestaurants extends React.PureComponent{
  constructor(props){
    super(props)
    this.state={imgEdit:null, imgNameEdit:null, imgError:"", logoEdit:null, logoNameEdit:null, logoError:"", placeError:"", addPlace:false,
                newPlaceName:"", newPlaceLocation:null, newPlaceAddress:"", placeSelected:"", canBook:false, canDDJJ:false,
                placeItemSelected:null, copyTickets:true, errorPlaceName:undefined, errorPlaceAddress:undefined,
                takeAway:false, delivery:false, table:false, isSuperAdmin:false, onlyMyDeliverys:false, 
                days:[{day:"Lunes", selected:false, booked:false}, 
                          {day:"Martes", selected:false, booked:false}, 
                          {day:"Miércoles", selected:false, booked:false}, 
                          {day:"Jueves", selected:false, booked:false}, 
                          {day:"Viernes", selected:false, booked:false}, 
                          {day:"Sábado", selected:false, booked:false}, 
                          {day:"Domingo", selected:false, booked:false}]}
    this.renderTableHeader=this.renderTableHeader.bind(this)
    this.renderTableBody=this.renderTableBody.bind(this)
    this.onClean=this.onClean.bind(this)
    this.onSave=this.onSave.bind(this)
    this.onSelectPlace=this.onSelectPlace.bind(this)
    // this.onChangePlace=this.onChangePlace.bind(this)
    // this.onChangePlacesName=this.onChangePlacesName.bind(this)
    this.onChangePlacesAddress=this.onChangePlacesAddress.bind(this)
    // this.getPlaces=this.getPlaces.bind(this)
    this.onSelectImage=this.onSelectImage.bind(this)
    this.onSelectLogo=this.onSelectLogo.bind(this)
    this.onChangeTable=this.onChangeTable.bind(this)
    this.onChangeDelivery=this.onChangeDelivery.bind(this)
    this.onChangeOnlyMyDeliverys=this.onChangeOnlyMyDeliverys.bind(this)
    this.onChangeTakeAway=this.onChangeTakeAway.bind(this)
    this.onChangeCanBook=this.onChangeCanBook.bind(this)
    this.onChangeCanDDJJ=this.onChangeCanDDJJ.bind(this)
    this.onChangeTab=this.onChangeTab.bind(this)
    _handleSubmitFail=this.handleSubmitFail.bind(this)
  }

  componentWillMount(){
    if(!this.props.login){
      this.props.history.replace(LOGIN_ROUTE);
    }
    let isSuperAdmin = this.props.profile&&(this.props.profile.proRoles.findIndex((r)=>{return r.id==Roles.SUPERADMIN})>=0)
    this.setState({isSuperAdmin:isSuperAdmin})
    if(this.props.isEditing||this.props.isCopy){
      let restaurant=this.props.restaurant
      if(restaurant){  
        // restaurant.evtDateTime = restaurant.evtDateTime&&Util.timestampToMoment(restaurant.evtDateTime).format('YYYY-MM-DDTHH:mm')
        // restaurant.evtInitDate = restaurant.evtInitDate&&Util.timestampToMoment(restaurant.evtInitDate).format('YYYY-MM-DDTHH:mm')
        // restaurant.evtEndDate = restaurant.evtEndDate&&Util.timestampToMoment(restaurant.evtEndDate).format('YYYY-MM-DDTHH:mm')
        let days = this.state.days.slice(0)
        let r = {...restaurant}
        if(restaurant.resScheduler){
          let rdays = Object.keys(restaurant.resScheduler)
          for(let i = 0;i<rdays.length;i++){
            let d = rdays[i]
            let idx = this.state.days.findIndex((day)=>{return this.toDayKey(day) == d})
            days[idx].selected = true
          }
        }
        if(restaurant.resBook){
          let rdays = Object.keys(restaurant.resBook)
          for(let i = 0;i<rdays.length;i++){
            let d = rdays[i]
            let idx = this.state.days.findIndex((day)=>{return this.toDayKey(day) == d})
            days[idx].booked = true
          }
        }
        // r.day = rdays
        this.props.initialize(r)
        // this.getPlaces(()=>{
        //   let placesFiltered = this.props.placeList.filter((p)=>{return p.plcName==restaurant.evtPlace})
        //   if(placesFiltered&&placesFiltered.length){
        //     this.setState({placeSelected:placesFiltered[0].plcName, placeItemSelected:placesFiltered[0]})
        //   }
        // })
        this.setState({imgEdit:restaurant.evtImg, imgNameEdit:restaurant.evtImgName, 
                      logoEdit:restaurant.resLogo, logoNameEdit:restaurant.resLogoName,
                      newPlaceAddress:restaurant.evtPlaceAddress, 
                      days:days, delivery:restaurant.resDelivery, takeAway:restaurant.resTakeAway, table:restaurant.resTable,
                      canBook:restaurant.resCanBook, canDDJJ:restaurant.resCanDDJJ})
      }else{
        this.props.history.replace(LOGIN_ROUTE);
      }
    }else{
      this.props.initialize({evtState:"active", resOpen:"open", resTakeAway:false, resDelivery:false, resTable:false})
     // this.getPlaces()

    }
  }

  // getPlaces(success){
  //   this.props.actionGetPlaces(
  //     success,
  //     (e)=>{
  //       if(!(e&&e.status&&e.status==401))
  //         Util.showNoty(ERROR, "No pudimos listar las ubicaciones")
  //     }
  //   )
  // }
  
  handleSubmitFail(error){
    if(this.props.isEditing&&!this.state.isSuperAdmin){
      if(error.evtImg){
        this.setState({imgError:error.evtImg})
      }
      if(error.evtPlaceAddress){
        this.setState({placeError:required(null)})
      }
    }
    // if(!this.state.placeSelected){
    //   this.setState({placeError:required(null)})
    // }
  }

  onClean(){
    if(this.props.isEditing){
      let restaurant=this.props.restaurant
      this.props.initialize({evtState:"active", resOpen:"open", evtImgPath:restaurant.evtImgPath, resLogoPath:restaurant.resLogoPath, id:restaurant.id})
    }else{
      this.props.initialize({evtState:"active", resOpen:"open"})
    }
    this.setState({imgEdit:null, imgNameEdit:null, imgError:"", logoEdit:null, logoNameEdit:null, logoError:"", 
        placeError:"", takeAway:false, delivery:false, table:false, newPlaceAddress:"", tabIndexSelected:0, canBook:false, canDDJJ:false,
        days:[{day:"Lunes", selected:false, booked:false}, 
              {day:"Martes", selected:false, booked:false}, 
              {day:"Miércoles", selected:false, booked:false}, 
              {day:"Jueves", selected:false, booked:false}, 
              {day:"Viernes", selected:false, booked:false}, 
              {day:"Sábado", selected:false, booked:false}, 
              {day:"Domingo", selected:false, booked:false}]})
  }

  toDayKey(d){
    return d.day.toLowerCase().replace('é','e').replace('á','a')
  }

  isValidSchedulerBook(f){
    let isValidScheduler = true
    let isValidBook = true
    let noSelected = true
    let noBooked = true
    for(let i=0;i<this.state.days.length;i++){
      let d = this.state.days[i]
      if(d.selected){
        noSelected = false
        if(f.resScheduler[this.toDayKey(d)]){
          let rd = f.resScheduler[this.toDayKey(d)]
          if(rd.start1&&!rd.end1 || !rd.start1&&rd.end1 || rd.start2&&!rd.end2 || !rd.start2&&rd.end2){
            isValidScheduler = false
            break;
          }
        }
      }
      if(d.booked){
        noBooked = false
        if(f.resBook[this.toDayKey(d)]){
          let rd = f.resBook[this.toDayKey(d)]
          if(rd.start1&&!rd.end1 || !rd.start1&&rd.end1 || rd.start2&&!rd.end2 || !rd.start2&&rd.end2){
            isValidBook = false
            break;
          }
        }
      }
    }
    if(!this.state.isSuperAdmin&&this.props.isEditing&&noSelected){
      isValidScheduler = false
    }
    return {isValidScheduler:isValidScheduler, isValidBook:isValidBook}
    
  }

  onSave(formValues){
    console.log("FORM VALUES", formValues, this.state.days)
    try{
      let isValid = true
      const isValidSchedulerBook = this.isValidSchedulerBook(formValues)
      if(!isValidSchedulerBook.isValidScheduler){
        Util.showNoty(ERROR, "Revise que los horarios de atención seleccionados tengan un desde y hasta válidos.")
        isValid = false
      }
      if(!isValidSchedulerBook.isValidBook){
        Util.showNoty(ERROR, "Revise que los horarios de reserva seleccionados tengan un desde y hasta válidos.")
        isValid = false
      }
      if(this.props.isEditing&&!this.state.isSuperAdmin){
        if(!this.state.delivery&&!this.state.takeAway&&!this.state.table){
          Util.showNoty(ERROR, "Indique si entregará el pedido por mesa, takeAway o delivery.")
          isValid = false
        }
      }

      if(formValues.resBookTime&&formValues.resBookTime<15){
        Util.showNoty(ERROR, "El tiempo entre reservas no puede ser menor a 15 minutos.")
        isValid = false
      }
      
      if(!isValid){
        return
      }
      const isCopyWithTickets = this.props.isCopy&&this.state.copyTickets
      if(this.props.isCopy&&!this.state.copyTickets){//Si estoy copiando pero no seleccionó la opción para copiar tickets
        delete formValues.id //Quito el id para que haga la copia del evento
      }

      let f = {...formValues}
      for(let p in f.resScheduler){
        if(this.state.days.findIndex((d)=>d.selected&&this.toDayKey(d)==p)<0){
            delete f.resScheduler[p]
        }
      }
      for(let p in f.resBook){
        if(this.state.days.findIndex((d)=>d.booked&&this.toDayKey(d)==p)<0){
            delete f.resBook[p]
        }
      }
      f.resTable=this.state.table
      f.resTakeAway=this.state.takeAway
      f.resDelivery=this.state.delivery
      f.resOnlyMyDeliverys=this.state.delivery&&this.state.onlyMyDeliverys?true:false
      f.resCanBook=this.state.canBook
      f.resCanDDJJ=this.state.canDDJJ
      if(!f.resDelivery){
        f.resDeliveryPrice=null
      }
      this.props.actionSaveRestaurant(f, isCopyWithTickets
        , ()=>{Util.showNoty(SUCCESS, "El comercio se guardó correctamente."); this.props.history.goBack()}
        , (e)=>{
          console.log("ERROR ON SAVE RESTAURANT", e)
          if(!(e&&e.status&&e.status==401))
            Util.showNoty(ERROR, "No se pudo guardar el comercio.")
        }
      )
    }catch(err){
      console.log("ERROR",err)
    }
  }

  onSelectPlace(){
    if(this.state.newPlaceAddress){
      let placeLocation ={_latitude:this.state.newPlaceLocation.lat(), _longitude:this.state.newPlaceLocation.lng()}
      // let place = {plcAddress:this.state.newPlaceAddress, plcCoordinates:placeLocation}
      this.props.change("evtPlaceAddress", this.state.newPlaceAddress)
      this.props.change("evtCoordinates", placeLocation)
      // this.props.actionSavePlace(place,
      //   ()=>this.getPlaces(this.onChangePlace(null, place)),
      //   (e)=>{
      //     console.log("ERROR ON SAVE NEW PLACE", e)
      //     if(!(e&&e.status&&e.status==401))
      //       Util.showNoty(ERROR, "No pudimos agregar la ubicación")
      //   }
      // )
      // this.setState({addPlace:false, placeSelected:place.plcName})
      this.setState({openPlace:false})
    }else{
      if(!this.state.newPlaceAddress){
        this.setState({errorPlaceAddress:"Debe ingresar una dirección para la ubicación"})
      }
    }
  }

  // onChangePlace(evt, place){
  //   if(place){
  //     // this.props.change("evtPlace", place.plcName)
  //     this.props.change("evtPlaceAddress", place.plcAddress)
  //     this.props.change("evtCoordinates", place.plcCoordinates)
  //     this.setState({placeError:""})
  //   }else{
  //     // this.props.change("evtPlace", null)
  //     this.props.change("evtPlaceAddress",null)
  //     this.props.change("evtCoordinates", null)
  //     // this.setState({placeSelected:"", placeItemSelected:null})
  //   } 
  // }
  
  onSelectImage(imgUrl, imgBlob, fileName){
      this.props.change("evtImg", {blob:imgBlob}) //No me deja setear el blob así que lo paso como un objeto con un blob
      this.props.change("evtImgName", fileName)
  }

  onSelectLogo(logoUrl, logoBlob, fileName){
    this.props.change("resLogo", {blob:logoBlob}) //No me deja setear el blob así que lo paso como un objeto con un blob
    this.props.change("resLogoName", fileName)
  }
  // onChangePlacesName(evt){
  //   const txt = evt.target.value
  //   if(txt){
  //     this.setState({newPlaceName:txt, errorPlaceName:undefined})
  //   }else{
  //     this.setState({newPlaceName:txt, errorPlaceName:"Debe ingresar un nombre para la ubicación"})
  //   }
  // }

  onChangePlacesAddress(evt){
    const txt = evt.target.value
    if(txt){
      this.setState({newPlaceAddress:txt, errorPlaceAddress:undefined})
    }else{
      this.setState({newPlaceAddress:txt, errorPlaceAddress:"Debe ingresar una dirección para la ubicación"})
    }
  }

  onChangeTable(event){
    this.setState({table:event.target.checked})
  }

  onChangeDelivery(event){
    if(event.target.checked){
      this.setState({delivery:event.target.checked})
    }else{
      this.setState({delivery:event.target.checked, onlyMyDeliverys:false})
    } 
  }

  onChangeOnlyMyDeliverys(event){
    this.setState({onlyMyDeliverys:event.target.checked})
  }

  onChangeTakeAway(event){
    this.setState({takeAway:event.target.checked})
  }

  onChangeCanBook(event){
    this.setState({canBook:event.target.checked})
  }

  onChangeCanDDJJ(event){
    this.setState({canDDJJ:event.target.checked})
  }

  onSelectDay(item, index, event){
    const isBooking = this.state.tabIndexSelected == 1
    let days = this.state.days.slice(0)
    console.log("CHECKED", event.target.checked)
    if(isBooking){
      days.splice(index, 1, {...item, booked:event.target.checked})
    }else{
      days.splice(index, 1, {...item, selected:event.target.checked})
    }
    this.setState({days:days})
  }

  onChangeTab(evt, newIndex){
    this.setState({tabIndexSelected:newIndex})
  }

  renderTableHeader(){
    const {theme} = this.props
    const headers = ["Seleccionar", "Día", "Inicio", "Fin", "Inicio", "Fin"]
    return (
    <TableRow>
      {headers.map((label)=>{
        return (
          <TableCell>{label}</TableCell>
        )
      })}
    </TableRow>
    )
  }

  renderTableBody(){
    const {theme} = this.props
    const isBooking = this.state.tabIndexSelected == 1
    const field = isBooking?"resBook":"resScheduler"
    return this.state.days.map((item, index)=>{
      return (
        <TableRow style={index%2==0?theme.addEditRestaurant.row:theme.addEditRestaurant.rowColor}>
          <TableCell style={theme.addEditRestaurant.cell}>
            <Checkbox color="primary" checked={!isBooking&&item.selected || isBooking&&item.booked} onChange={this.onSelectDay.bind(this, item, index)}/>  
          </TableCell>
          <TableCell style={theme.addEditRestaurant.cell}>
            {item.day}
          </TableCell>
          <TableCell style={theme.addEditRestaurant.cell}>
            <Field
              component={TextField}
              name={`${field}.${this.toDayKey(item)}.start1`}
              type="time"
              step="300"
              disabled={!isBooking&&!item.selected ||isBooking&&!item.booked}
            />
          </TableCell>
          <TableCell style={theme.addEditRestaurant.cell}>
            <Field
              component={TextField}
              name={`${field}.${this.toDayKey(item)}.end1`}
              type="time"
              step="300"
              disabled={!isBooking&&!item.selected ||isBooking&&!item.booked}
            />
          </TableCell>
          <TableCell style={theme.addEditRestaurant.cell}>
            <Field
              component={TextField}
              name={`${field}.${this.toDayKey(item)}.start2`}
              type="time"
              step="300"
              disabled={!isBooking&&!item.selected ||isBooking&&!item.booked}

            />
          </TableCell>
          <TableCell style={theme.addEditRestaurant.cell}>
            <Field
              component={TextField}
              name={`${field}.${this.toDayKey(item)}.end2`}
              type="time"
              step="300"
              disabled={!isBooking&&!item.selected ||isBooking&&!item.booked}
            />
          </TableCell>
        </TableRow>
      )
    })
  }
  render(){
    const { theme, handleSubmit, isEditing, isCopy, formRestaurant } = this.props
    const title = isEditing?"Editar Comercio":(isCopy?"Copiar Comercio":"Crear Comercio")
    return (
      <Box style={theme.mainContainer}>
        <Box style={{...theme.title.container, flexDirection:"row", display:"flex"}}>
          <Box style={theme.title.backIconContainer}>
            <IconButton onClick={this.props.history.goBack} style={theme.title.backIcon}>
              <BackIcon style={{fontSize:"2.5rem"}} stroke="white" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round"/>
            </IconButton>
          </Box>
          <Box>
            <Typography variant="h1">Crear Comercios</Typography>
            <Typography variant="subtitle1">Crea Comercios</Typography>
          </Box>
        </Box>
        <Container>        
          <Paper >
            <Typography style={theme.paper.title} variant="h2">{title}</Typography>
            <form style={theme.paper.form}>
              <Grid container xs={12} spacing={3} direction="row">
                <Grid item xs={3}>
                  <Field
                    component={TextField}
                    name="evtTitle"
                    label="Nombre de Comercio"
                    fullWidth
                    validate={[required]}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Field
                    component={TextField}
                    name="resRazonSocial"
                    label="Razón Social"
                    fullWidth
                    disabled={!this.state.isSuperAdmin}
                    validate={[required]}
                  />
                </Grid>
                <Grid item xs={2}>
                  <Field
                    component={TextField}
                    name="resCuit"
                    label="CUIT"
                    fullWidth
                    disabled={!this.state.isSuperAdmin}
                    validate={[required]}
                  />
                </Grid>
                <Grid item xs={2}  style={{maxWidth:130}}>
                  <InputLabel shrink>¿Comercio Activo?</InputLabel>
                  <Field
                    component={Select}
                    select
                    name="evtState"
                    fullWidth
                    validate={[required]}
                  >
                    <MenuItem value="active">ACTIVO</MenuItem>
                    <MenuItem value="inactive">INACTIVO</MenuItem>
                  </Field>  
                </Grid>
                <Grid item xs={2}  style={{maxWidth:130}}>
                  <InputLabel shrink>¿Comercio Abierto?</InputLabel>
                  <Field
                    component={Select}
                    select
                    name="resOpen"
                    fullWidth
                    validate={[required]}
                  >
                    <MenuItem value="open">ABIERTO</MenuItem>
                    <MenuItem value="close">CERRADO</MenuItem>
                  </Field>  
                </Grid>
                {this.props.isCopy&&
                  <Grid item xs={2} spacing={0} justify="center" style={{maxWidth:100}}>
                    <InputLabel shrink>¿Copiar Items de menú?</InputLabel>
                    <SelectMaterial
                      fullWidth
                      validate={[required]}
                      value={this.state.copyTickets}
                      onChange={(evt)=>{this.setState({copyTickets:evt.target.value})}}
                    >
                      <MenuItem value={true}>SI</MenuItem>
                      <MenuItem value={false}>NO</MenuItem>
                    </SelectMaterial>
                  </Grid>
                  }
              </Grid>
              <Grid container direction="row" spacing={3}>
                <Grid item xs={4}>
                  <Tooltip title="Subí la imagen en 440x247">
                    <FormControl fullWidth error={this.state.imgError?true:false}>
                      <ImageSelector
                        fieldName="evtImg"
                        validate={!this.state.isSuperAdmin&&this.props.isEditing&&[required]}
                        // fileDimentions={{ width: 750, height: 370 }}
                        styleButton={theme.imageSelector}
                        imagePreviewUrl={this.state.imgEdit}
                        fileName={this.state.imgNameEdit}
                        fileSize={400000}
                        maxWidth={440}
                        maxHeight={247}
                        noPreview
                        onChangeState={()=>{this.setState({imgError:""})}}
                        crop={{
                          aspect: 440/247,
                          x: 0,
                          y: 0,
                          width: 440,
                          height: 247,
                          // unit:"px"
                        }}
                        onSelect={this.onSelectImage}
                      />
                      <FormHelperText>{this.state.imgError}</FormHelperText>
                    </FormControl>
                  </Tooltip>
                </Grid>
                <Grid item xs={4} >
                  <Field
                    component={TextField}
                    name="evtDescription"
                    label="Descripción"
                    fullWidth
                    multiline
                    rows={4}
                    inputProps={{maxlength:100}}
                    validate={!this.state.isSuperAdmin&&this.props.isEditing&&[required]}
                  />
                </Grid>
                <Grid item xs={4} >
                  
                  <InputLabel shrink>Logo</InputLabel>
                  <Tooltip title="Subí la imagen en 400x200">
                  <FormControl fullWidth error={this.state.logoError?true:false} alignItems="center">
                    <ImageSelector
                      fieldName="resLogo"
                      validate={!this.state.isSuperAdmin&&this.props.isEditing&&[required]}
                      // fileDimentions={{ width: 750, height: 370 }}
                      styleButton={theme.imageSelector}
                      imagePreviewUrl={this.state.logoEdit}
                      fileName={this.state.logoNameEdit}
                      fileSize={400000}
                      maxWidth={400}
                      maxHeight={200}
                      noPreview
                      onChangeState={()=>{this.setState({logoError:""})}}
                      crop={{
                        aspect: 400/200,
                        x: 0,
                        y: 0,
                        width: 400,
                        height: 200,
                        // unit:"px"
                      }}
                      onSelect={this.onSelectLogo}
                    />
                    <FormHelperText>{this.state.logoError}</FormHelperText>
                  </FormControl>
                  </Tooltip>
                </Grid>
              </Grid>
              <Grid container xs={12} spacing={3}>
                <Grid item xs={2}>
                  <Field
                      component={TextField}
                      name="resTableCashTaxes"
                      label="Comisión Mesa"
                      fullWidth
                      format={Util.formatNumberWith0}
                      parse={Util.toNumber}
                      InputProps={{ endAdornment:<InputAdornment position="end">%</InputAdornment>,
                      startAdornment:<InputAdornment position="start">Efectivo</InputAdornment>,
                      inputProps:{style:{textAlign:"end"} }}}
                      InputLabelProps={{ shrink: true }}
                      disabled={!this.state.isSuperAdmin}
                      validate={this.state.isSuperAdmin&&[required, typeIntegerOrDecimalOr0]}
                    />
                </Grid>
                <Grid item xs={2}>
                  <Field
                      component={TextField}
                      name="resTableCardTaxes"
                      label="Comisión Mesa"
                      fullWidth
                      format={Util.formatNumberWith0}
                      parse={Util.toNumber}
                      InputProps={{ endAdornment:<InputAdornment position="end">%</InputAdornment>,
                                    startAdornment:<InputAdornment position="start">Tarjeta</InputAdornment>,
                                    inputProps:{style:{textAlign:"end"} }}}
                      InputLabelProps={{ shrink: true }}
                      disabled={!this.state.isSuperAdmin}
                      validate={this.state.isSuperAdmin&&[required, typeIntegerOrDecimalOr0]}
                    />
                </Grid>
                <Grid item xs={2}>
                  <Field
                      component={TextField}
                      name="resDeliveryTakeAwayCashTaxes"
                      label="Comisión Delivery/Take Away"
                      fullWidth
                      format={Util.formatNumberWith0}
                      parse={Util.toNumber}
                      InputProps={{ endAdornment:<InputAdornment position="end">%</InputAdornment> ,
                      startAdornment:<InputAdornment position="start">Efectivo</InputAdornment>,
                      inputProps:{style:{textAlign:"end"} }}}
                      InputLabelProps={{ shrink: true }}
                      disabled={!this.state.isSuperAdmin}
                      validate={this.state.isSuperAdmin&&[required, typeIntegerOrDecimalOr0]}
                    />
                </Grid>
                <Grid item xs={2}>
                  <Field
                      component={TextField}
                      name="resDeliveryTakeAwayCardTaxes"
                      label="Comisión Delivery/Take Away"
                      fullWidth
                      format={Util.formatNumberWith0}
                      parse={Util.toNumber}
                      InputProps={{ endAdornment:<InputAdornment position="end">%</InputAdornment>,
                      startAdornment:<InputAdornment position="start">Tarjeta</InputAdornment>,
                      inputProps:{style:{textAlign:"end"} }}}
                      InputLabelProps={{ shrink: true }}
                      disabled={!this.state.isSuperAdmin}
                      validate={this.state.isSuperAdmin&&[required, typeIntegerOrDecimalOr0]}
                    />
                </Grid>
                <Grid item xs={2}>
                  <Field
                      component={TextField}
                      name="resTableCardRecharge"
                      label="Recarga Mesa"
                      fullWidth
                      format={Util.formatNumberWith0}
                      parse={Util.toNumber}
                      InputProps={{ endAdornment:<InputAdornment position="end">%</InputAdornment>,
                      startAdornment:<InputAdornment position="start">Tarjeta</InputAdornment>,
                      inputProps:{style:{textAlign:"end"} }}}
                      InputLabelProps={{ shrink: true }}
                      validate={[required, typeIntegerOrDecimalOr0]}
                    />
                </Grid>
                <Grid item xs={2}>
                  <Field
                      component={TextField}
                      name="resDeliveryTakeAwayCardRecharge"
                      label="Recarga Delivery/Take Away"
                      fullWidth
                      format={Util.formatNumberWith0}
                      parse={Util.toNumber}
                      InputProps={{ endAdornment:<InputAdornment position="end">%</InputAdornment>,
                      startAdornment:<InputAdornment position="start">Tarjeta</InputAdornment>,
                      inputProps:{style:{textAlign:"end"} }}}
                      InputLabelProps={{ shrink: true }}
                      validate={[required, typeIntegerOrDecimalOr0]}
                    />
                </Grid>
              </Grid>
              <Grid container xs={12} spacing={3}>
                <Grid item xs={4}>
                  <FormControl fullWidth error={this.state.placeError?true:false} style={{alignItems:"flex-start"}}>
                    <Button onClick={()=>{this.setState({openPlace:true})}}>{this.state.newPlaceAddress || "Seleccionar Dirección"}</Button>
                    <FormHelperText>{this.state.placeError}</FormHelperText>
                  </FormControl>
                </Grid>
                <Grid item xs={1} alignItems="center" justify="center"> 
                  <InputLabel shrink>Resevas</InputLabel>
                  <Checkbox
                    checked={this.state.canBook}
                    color="primary"
                    onChange={this.onChangeCanBook}
                  />
                </Grid>
                <Grid item xs={1} alignItems="center" justify="center"> 
                  <InputLabel shrink>DDJJ</InputLabel>
                  <Checkbox
                    checked={this.state.canDDJJ}
                    color="primary"
                    onChange={this.onChangeCanDDJJ}
                  />
                </Grid>
                <Grid item xs={2}>
                  <Field
                      component={TextField}
                      name="resPhone"
                      label="Teléfono"
                      InputLabelProps={{ shrink: true }}
                      validate={!this.state.isSuperAdmin&&this.props.isEditing&&[required, typeInteger]}
                    />
                </Grid>
                <Grid item xs={2}>
                  <Field
                      component={TextField}
                      name="resOrderTime"
                      label="Tiempo de Pedido"
                      format={Util.formatNumber}
                      parse={Util.toNumber}
                      InputLabelProps={{ shrink: true }}
                      InputProps={{ endAdornment:<InputAdornment position="end">min</InputAdornment> }}
                      validate={!this.state.isSuperAdmin&&this.props.isEditing&&[required, typeInteger]}
                    />
                </Grid>
                <Grid item xs={2} >
                  <Field
                      component={TextField}
                      name="resOrderRadio"
                      label="Radio de Entrega"
                      format={Util.formatNumber}
                      parse={Util.toNumber}
                      InputLabelProps={{ shrink: true }}
                      InputProps={{ endAdornment:<InputAdornment position="end">Km</InputAdornment> }}
                      validate={!this.state.isSuperAdmin&&this.props.isEditing&&[required, typeInteger]}
                    />
                </Grid>
              </Grid>
              <Grid container xs={12} spacing={3}>
                {/* <Grid item container xs={6} spacing={2} alignItems="flex-start" justify="center" direction="row"> */}
                  <Grid item alignItems="center" justify="center">
                    <InputLabel shrink>Mesa</InputLabel>
                    <Checkbox
                      checked={this.state.table}
                      color="primary"
                      onChange={this.onChangeTable}
                    />
                  </Grid>
                  <Grid item alignItems="center" justify="center"> 
                      <InputLabel shrink>Take Away</InputLabel>
                      <Checkbox
                        checked={this.state.takeAway}
                        color="primary"
                        onChange={this.onChangeTakeAway}
                      />
                  </Grid>
                  <Grid item xs={2} alignItems="center" justify="center">
                    <InputLabel shrink>Delivery</InputLabel>
                    <Checkbox
                      checked={this.state.delivery}
                      onChange={this.onChangeDelivery}
                      color="primary"
                    />
                  </Grid>
                  <Grid item xs={2} alignItems="center" justify="center">
                    <InputLabel shrink>Sólo mis deliverys</InputLabel>
                    <Checkbox
                      disabled={!this.state.delivery}
                      checked={this.state.onlyMyDeliverys}
                      onChange={this.onChangeOnlyMyDeliverys}
                      color="primary"
                    />
                  </Grid>
                {/* </Grid> */}
                <Grid item xs={2} >
                  <Field
                    component={TextField}
                    InputProps={{
                      startAdornment:<InputAdornment position="start">$</InputAdornment>
                    }}
                    format={Util.formatNumber}
                    parse={Util.toNumber}
                    name="resDeliveryPrice"
                    label="Valor del Delivery por KM"
                    fullWidth
                    // disabled={!this.state.delivery}
                    validate={this.state.delivery&&[required, typeIntegerOrDecimalOr0]}
                  />
                </Grid>
                <Grid item xs={2} >
                  <Field
                    component={TextField}
                    InputProps={{
                      startAdornment:<InputAdornment position="start">$</InputAdornment>
                    }}
                    format={Util.formatNumber}
                    parse={Util.toNumber}
                    name="resMinOrderPrice"
                    label="Pedido mínimo "
                    fullWidth
                    // disabled={!this.state.delivery}
                    validate={this.state.delivery&&[typeIntegerOrDecimalOr0]}
                  />
                </Grid>
                <Grid item xs={2} >
                  <Field
                    component={TextField}
                    InputProps={{
                      startAdornment:<InputAdornment position="start">$</InputAdornment>
                    }}
                    format={Util.formatNumber}
                    parse={Util.toNumber}
                    name="resMinOrderBonif"
                    label="Bonificar delivery superior a"
                    fullWidth
                    disabled={!this.state.delivery}
                    validate={this.state.delivery&&[typeIntegerOrDecimalOr0]}
                  />
                </Grid>
              </Grid>
              <Grid container xs={12} spacing={3}>
                <Grid item xs={4}>
                  <Field
                      component={TextField}
                      name="resFacebook"
                      label="Facebook"
                      style={{width:"87%"}}
                      InputLabelProps={{ shrink: true }}
                      InputProps={{
                        startAdornment:<InputAdornment position="start">www.facebook.com/</InputAdornment> }}
                    />
                    <Tooltip title="Abrir Facebook">
                      <IconButton style={{top:10}} href={`https://www.facebook.com/${formRestaurant.resFacebook}`} target="_blank" disabled={!formRestaurant.resFacebook}>
                        <FacebookIcon fontSize="large"/>
                      </IconButton>
                    </Tooltip>
                </Grid>
                <Grid item xs={4}>
                  <Field
                      component={TextField}
                      name="resInstagram"
                      label="Instagram"
                      InputLabelProps={{ shrink: true }}
                      style={{width:"87%"}}
                      InputProps={{
                        startAdornment:<InputAdornment position="start">www.instagram.com/</InputAdornment>  }}
                    />
                    <Tooltip title="Abrir Instagram">
                      <IconButton style={{top:10}} href={`https://www.instagram.com/${formRestaurant.resInstagram}`} target="_blank" disabled={!formRestaurant.resInstagram}>
                        <InstagramIcon fontSize="large"/>
                      </IconButton>
                    </Tooltip>
                </Grid>
                <Grid item xs={4}>
                  <Field
                      component={TextField}
                      name="resTwitter"
                      label="Twitter"
                      InputLabelProps={{ shrink: true }}
                      style={{width:"87%"}}
                      InputProps={{
                        startAdornment:<InputAdornment position="start">www.twitter.com/</InputAdornment>  }}
                    />
                    <Tooltip title="Abrir Twitter">
                      <IconButton style={{top:10}} href={`https://www.twitter.com/${formRestaurant.resTwitter}`} target="_blank" disabled={!formRestaurant.resTwitter}>
                        <TwitterIcon fontSize="large"/>
                      </IconButton>
                    </Tooltip>
                </Grid>
              </Grid>
              <Grid container item xs={12} spacing={3}>
                <Tabs value={this.state.tabIndexSelected} style={{backgroundColor:"black", color:"white", marginTop:20}} onChange={this.onChangeTab}>
                  <Tab label="Horarios de Atención"/>
                  <Tab label="Horarios de Reserva"/>
                </Tabs>
                {this.state.tabIndexSelected?
                <Field
                      style={{marginTop:20, marginLeft:20}}
                      component={TextField}
                      name="resBookTime"
                      label="Tiempo entre reservas"
                      format={Util.formatNumber}
                      parse={Util.toNumber}
                      InputLabelProps={{ shrink: true }}
                      InputProps={{ endAdornment:<InputAdornment position="end">min</InputAdornment> }}
                      validate={!this.state.isSuperAdmin&&this.props.isEditing&&[required, typeInteger]}
                    />:null}
                <Table stickyHeader style={{borderColor:"rgb(224,224,224,1)", borderStyle:"solid", borderWidth:1}}>
                  <TableHead > 
                    {this.renderTableHeader()}
                  </TableHead>
                  <TableBody>
                    {this.renderTableBody()}
                  </TableBody>
                </Table> 
              </Grid> 
            </form>
          </Paper>
          <Toolbar style={theme.footer.toolbar}>
            <Tooltip title="Limpiar">
              <Button variant="contained" color="secondary" style={theme.footer.button} onClick={this.onClean}>Limpiar</Button>
            </Tooltip>
            <Tooltip title="Cancelar">
              <Button variant="contained" color="secondary" style={theme.footer.button} onClick={this.props.history.goBack}>Cancelar</Button>
            </Tooltip>
            <Tooltip title="Guardar">
              <Button variant="contained" color="primary" style={theme.footer.button} onClick={handleSubmit(this.onSave)}>Guardar</Button>
            </Tooltip>
          </Toolbar>
        </Container>
        <Dialog open={this.state.openPlace} draggable
                onClose={()=>this.setState({openPlace:false})} 
                disableBackdropClick 
                fullWidth
                style={{zIndex:900}}
                PaperProps={{style:{maxWidth:800}}}>
                  
          <DialogTitle>
            Ubicación
          </DialogTitle>
          <DialogTitle>
            <Box className="display-flex">
              {/* <TextField label="Nombre" 
                         fullWidth 
                         value={this.state.newPlaceName} 
                         onChange={this.onChangePlacesName}
                         error={this.state.errorPlaceName?true:false}
                         helperText={this.state.errorPlaceName}/> */}
              <TextField label="Dirección" 
                         fullWidth 
                         value={this.state.newPlaceAddress} 
                         onChange={this.onChangePlacesAddress} 
                         style={{marginLeft:10}}
                         error={this.state.errorPlaceAddress?true:false}
                         helperText={this.state.errorPlaceAddress}
                         />
            </Box>
          </DialogTitle>
          <GoogleMapLocation onChangeLocation={(value)=>this.setState({newPlaceLocation:value})}
                             onChangeAddress={(value)=>this.setState({newPlaceAddress:value})}/>
          <DialogActions>
            <Tooltip title="Cerrar">
              <Button variant="contained" color="secondary" onClick={()=>this.setState({openPlace:false})} >Cerrar</Button>
            </Tooltip>
            <Tooltip title="Seleccionar">
              <Button variant="contained" color="primary" onClick={this.onSelectPlace}>Seleccionar</Button>
            </Tooltip>
          </DialogActions>
        </Dialog>
      </Box>
    )
  }
}
function mapStateToProps(store) {
  return {
    login: store.auth.login,
    placeList: store.plc.placeList,
    restaurant: store.evt.restaurant,
    profile: store.auth.profile,
    formRestaurant: store.form.addEditRestaurant&&store.form.addEditRestaurant.values||{}
    //eventPlace: store.form.addEditRestaurant
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      actionSaveRestaurant,
      actionSavePlace
    },
    dispatch
  );
}

export default  reduxForm({
  form: "addEditRestaurant",
  onSubmitFail: errors => _handleSubmitFail(errors)
})(withRouter(
    withTheme(
      connect(
        mapStateToProps,
        mapDispatchToProps
      )(AddEditRestaurants)
    )
  )
)


// WEBPACK FOOTER //
// ./src/screens/restaurants/AddEditRestaurant.js